import React from "react";
import {Row,Col,Button,Modal} from "react-bootstrap";
class DeleteState extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  Submit = () => {
    this.props.deleteState(this.props.DeleteItems);
    this.props.closeDeleteModel();
    this.props.resetPage();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showDelete}
          animation={false}
          size="md"
          backdrop="static"
          onHide={this.props.closeDeleteModel}
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
          >
            <Modal.Title>
              <span style={{ fontSize: "20px" }}>Delete State</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b>Are you sure you want to delete?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  //  style={styles.ActiveBtn}
                  variant="danger"
                  className="cmnDelCnclBtn"
                  onClick={() => this.props.closeDeleteModel()}
                >
                  CANCEL
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  // style={styles.suspndBtn}
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={this.Submit}
                >
                  OK
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default DeleteState;
